import Marionette from "marionette";
import DragDrop from "../../../DragDrop";
import template from "classes/modals/cam/view/template/ControlsView.html";
import "css!classes/modals/cam/view/css/ControlsView";


let ControlsView = Marionette.ItemView.extend("ControlsView", {
    className: "Controls",
    template,

    ui: {
        $play: ".play",
        $pause: ".pause",
        $capture: ".capture",
        $fullscreen: ".fullscreen",
        $settings: ".settings",

        $crop: ".crop",

        $cornerTopLeft: ".corner-top-left",
        $cornerTopRight: ".corner-top-right",
        $cornerBottomLeft: ".corner-bottom-left",
        $cornerBottomRight: ".corner-bottom-right",

        $cornerTop: ".corner-top",
        $cornerLeft: ".corner-left",
        $cornerRight: ".corner-right",
        $cornerBottom: ".corner-bottom",

        $cropShadowTop: ".crop-shadow-top",
        $cropShadowLeft: ".crop-shadow-left",
        $cropShadowRight: ".crop-shadow-right",
        $cropShadowBottom: ".crop-shadow-bottom"
    },

    events: {
        "click @ui.$play": "onPlay",
        "click @ui.$pause": "onPause",
        "click @ui.$capture": "onCapture",
        "click @ui.$fullscreen": "onFullscreen",
        "click @ui.$settings": "onSettings"
    },

    modelEvents: {
        "change:ratio": "onChangeRatio"
    },

    initialize() {
        this._lastRect = null;
    },

    onRender() {
        this.initDragDrop();
    },

    initDragDrop() {
        // перемещение области
        let cropMove = new DragDrop();
        cropMove.addElem(this.ui.$crop);

        cropMove.on("start", function(e) {
            if ( e.$target.hasClass("corner") ) {
                return e.cancel();
            }

            e.set("offsetLeft", this.model.get("offsetLeft"));
            e.set("offsetTop", this.model.get("offsetTop"));
        }.bind(this));

        cropMove.on("move end", function(e) {
            if ( !this._lastRect ) {
                return;
            }

            let offsetLeft = e.start.get("offsetLeft") + e.dx;
            let offsetTop = e.start.get("offsetTop") + e.dy;
            offsetLeft = Math.max(0, offsetLeft);
            offsetTop = Math.max(0, offsetTop);
            offsetLeft = Math.min(offsetLeft, -this.model.get("offsetWidth"));
            offsetTop = Math.min(offsetTop, -this.model.get("offsetHeight"));

            this.model.set("offsetLeft", offsetLeft);
            this.model.set("offsetTop", offsetTop);

            this.drawCropRect();
        }.bind(this));

        // изменение размера области
        let cropSize = new DragDrop();
        cropSize.addElem(this.ui.$cornerTopLeft);
        cropSize.addElem(this.ui.$cornerTopRight);
        cropSize.addElem(this.ui.$cornerBottomLeft);
        cropSize.addElem(this.ui.$cornerBottomRight);
        cropSize.addElem(this.ui.$cornerTop);
        cropSize.addElem(this.ui.$cornerLeft);
        cropSize.addElem(this.ui.$cornerRight);
        cropSize.addElem(this.ui.$cornerBottom);

        cropSize.on("start", function(e) {
            let type;
            if ( e.$elem.hasClass("corner-top-left") ) {
                type = "tl";
            }
            else if ( e.$elem.hasClass("corner-top-right") ) {
                type = "tr";
            }
            else if ( e.$elem.hasClass("corner-bottom-left") ) {
                type = "bl";
            }
            else if ( e.$elem.hasClass("corner-bottom-right") ) {
                type = "br";
            }
            else if ( e.$elem.hasClass("corner-bottom") ) {
                type = "b";
            }
            else if ( e.$elem.hasClass("corner-top") ) {
                type = "t";
            }
            else if ( e.$elem.hasClass("corner-left") ) {
                type = "l";
            }
            else if ( e.$elem.hasClass("corner-right") ) {
                type = "r";
            }

            if ( !type ) {
                return e.cancel();
            }

            e.set("type", type);

            e.set("offsetWidth", this.model.get("offsetWidth"));
            e.set("offsetHeight", this.model.get("offsetHeight"));
            e.set("offsetTop", this.model.get("offsetTop"));
            e.set("offsetLeft", this.model.get("offsetLeft"));
        }.bind(this));

        cropSize.on("move end", function(e) {
            let rect = this._lastRect;
            if ( !rect ) {
                return;
            }

            let
                offsetWidth = e.start.get("offsetWidth");
            let offsetHeight = e.start.get("offsetHeight");
            let offsetTop = e.start.get("offsetTop");
            let offsetLeft = e.start.get("offsetLeft");
            let startOffsetWidth = offsetWidth;
            let startOffsetHeight = offsetHeight;
            let startOffsetTop = offsetTop;
            let startOffsetLeft = offsetLeft;
            let ratio = this.model.get("ratio");
            let type = e.start.get("type");

            if ( type == "br" ) {
                offsetWidth = startOffsetWidth + e.dx;
                offsetWidth = Math.min(offsetWidth, -startOffsetLeft);
                offsetHeight = startOffsetHeight + e.dy;
                offsetHeight = Math.min(offsetHeight, -startOffsetTop);
            }
            if ( type == "tr" ) {
                offsetWidth = startOffsetWidth + e.dx;
                offsetWidth = Math.min(offsetWidth, -startOffsetLeft);
                offsetHeight = startOffsetHeight - e.dy;
                offsetHeight = Math.min(
                    offsetHeight,
                    startOffsetHeight
                        + startOffsetTop
                );
                offsetTop = startOffsetTop + e.dy;
                offsetTop = Math.max(offsetTop, 0);
            }
            if ( type == "bl" ) {
                offsetWidth = startOffsetWidth - e.dx;
                offsetWidth = Math.min(
                    offsetWidth,
                    startOffsetWidth
                        + startOffsetLeft
                );
                offsetHeight = startOffsetHeight + e.dy;
                offsetHeight = Math.min(offsetHeight, -startOffsetTop);
                offsetLeft = startOffsetLeft + e.dx;
                offsetLeft = Math.max(offsetLeft, 0);
            }
            if ( type == "tl" ) {
                offsetWidth = startOffsetWidth - e.dx;
                offsetWidth = Math.min(
                    offsetWidth,
                    startOffsetWidth
                        + startOffsetLeft
                );
                offsetHeight = startOffsetHeight - e.dy;
                offsetHeight = Math.min(
                    offsetHeight,
                    startOffsetHeight
                        + startOffsetTop
                );
                offsetLeft = startOffsetLeft + e.dx;
                offsetLeft = Math.max(offsetLeft, 0);
                offsetTop = startOffsetTop + e.dy;
                offsetTop = Math.max(offsetTop, 0);
            }
            if ( type == "b" ) {
                offsetHeight = startOffsetHeight + e.dy;
                offsetHeight = Math.min(
                    offsetHeight,
                    -startOffsetTop
                );
            }
            if ( type == "r" ) {
                offsetWidth = startOffsetWidth + e.dx;
                offsetWidth = Math.min(
                    offsetWidth,
                    -startOffsetLeft
                );
            }
            if ( type == "t" ) {
                offsetTop = startOffsetTop + e.dy;
                offsetTop = Math.max(offsetTop, 0);
                offsetHeight = startOffsetHeight - e.dy;
                offsetHeight = Math.min(
                    startOffsetTop
                        + startOffsetHeight,
                    offsetHeight
                );
            }
            if ( type == "l" ) {
                offsetLeft = startOffsetLeft + e.dx;
                offsetLeft = Math.max(offsetLeft, 0);
                offsetWidth = startOffsetWidth - e.dx;
                offsetWidth = Math.min(
                    startOffsetLeft
                        + startOffsetWidth,
                    offsetWidth
                );
            }

            if ( ratio ) {
                let mw = (rect.height - offsetTop) * ratio;
                let mh = (rect.width - offsetLeft) / ratio;
                let sw = rect.width + startOffsetWidth;
                let sh = rect.height + startOffsetHeight;
                let sl = startOffsetLeft;
                let st = startOffsetTop;

                if ( type == "r" || type == "l" ) {
                    offsetHeight = startOffsetHeight + (offsetWidth - startOffsetWidth) / ratio;
                    offsetHeight = Math.min(-offsetTop, offsetHeight);
                    offsetWidth = Math.min(
                        offsetWidth,
                        mw - rect.width
                    );
                    offsetHeight = Math.min(
                        offsetHeight,
                        mh - rect.height
                    );
                    if ( type == "l" ) {

                        offsetLeft = Math.max(
                            offsetLeft,
                            sl + sw - mw
                        );
                    }
                }
                if ( type == "b" || type == "t" ) {
                    offsetWidth = startOffsetWidth + (offsetHeight - startOffsetHeight) * ratio;
                    offsetWidth = Math.min(-offsetLeft, offsetWidth);
                    offsetHeight = Math.min(
                        offsetHeight,
                        mh - rect.height
                    );

                    if ( type == "t" ) {

                        offsetTop = Math.max(
                            offsetTop,
                            st + sh - mh
                        );
                    }
                }
            }

            this.model.set("offsetTop", offsetTop);
            this.model.set("offsetLeft", offsetLeft);
            this.model.set("offsetWidth", offsetWidth);
            this.model.set("offsetHeight", offsetHeight);

            this.drawCropRect();
        }.bind(this));
    },

    onPlay(e) {
        e.preventDefault();
        this.model.set({
            play: true,
            runned: true
        });
        this.trigger("play");
        this.render();
    },

    onPause(e) {
        e.preventDefault();
        this.model.set("play", false);
        this.trigger("pause");
        this.render();
    },

    pause() {
        this.model.set("play", false);
        this.render();
    },

    onCapture(e) {
        e.preventDefault();
        if ( !this.model.get("runned")
            || this.model.get("captureLoading") ) {
            return;
        }

        this.trigger("capture");
    },

    onFullscreen(e) {
        e.preventDefault();
        this.trigger("fullscreen");
    },

    onSettings(e) {
        e.preventDefault();
        this.trigger("settings");
    },

    startCaptureLoading() {
        this.ui.$capture.addClass("loading");
        this.model.set("captureLoading", true);
    },

    stopCaptureLoading() {
        this.ui.$capture.removeClass("loading");
        this.model.set("captureLoading", false);
    },

    drawCropRect(rect) {
        rect = rect || this._lastRect;

        if ( !rect || !this.ui.$crop ) {
            return;
        }

        let ratio = +this.model.get("ratio");
        let offsetTop = this.model.get("offsetTop");
        let offsetLeft = this.model.get("offsetLeft");
        let offsetWidth = this.model.get("offsetWidth");
        let offsetHeight = this.model.get("offsetHeight");

        this.ui.$crop.toggleClass("has-ratio", !!ratio);

        this.ui.$crop.css({
            position: "absolute",
            top: rect.top + offsetTop + "px",
            left: rect.left + offsetLeft + "px",
            width: rect.width + offsetWidth + "px",
            height: rect.height + offsetHeight + "px"
        });

        this.ui.$cropShadowTop.css({
            left: 0 + "px",
            width: rect.width + "px",
            height: rect.top + offsetTop + "px"
        });
        this.ui.$cropShadowBottom.css({
            left: 0 + "px",
            bottom: rect.top + "px",
            width: rect.width + "px",
            height: -offsetHeight - offsetTop + "px"
        });
        this.ui.$cropShadowLeft.css({
            left: 0 + "px",
            top: rect.top + offsetTop + "px",
            width: offsetLeft + "px",
            height: rect.height + offsetHeight + "px"
        });
        this.ui.$cropShadowRight.css({
            right: rect.left + "px",
            top: rect.top + offsetTop + "px",
            width: -offsetWidth - offsetLeft + "px",
            height: rect.height + offsetHeight + "px"
        });

        this._lastRect = rect;
    },

    onChangeRatio() {
        let rect = this._lastRect;
        if ( !rect ) {
            return;
        }

        let ratio = this.model.get("ratio");
        if ( !ratio ) {
            this.model.set("offsetTop", 0);
            this.model.set("offsetHeight", 0);
            this.model.set("offsetWidth", 0);
            this.model.set("offsetLeft", 0);
        } else {
            let camRatio = rect.width / rect.height;
            if ( camRatio > ratio ) {
                let width = rect.height * ratio;
                width = rect.width - width;

                this.model.set("offsetTop", 0);
                this.model.set("offsetHeight", 0);
                this.model.set("offsetWidth", -width);
                this.model.set("offsetLeft", width / 2);
            } else {
                let height = rect.width / ratio;
                height = rect.height - height;

                this.model.set("offsetTop", height / 2);
                this.model.set("offsetHeight", -height);
                this.model.set("offsetWidth", 0);
                this.model.set("offsetLeft", 0);
            }
        }

        this.drawCropRect();
    }
});

export default ControlsView;
